import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import "../../assets/css/Loader.css";
import { useToast } from "../Toast/ToastContext";
import { useNavigate } from "react-router-dom";

function ExpenseType() {
  const navigate = useNavigate();
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState([]);
  const [addData, setAddData] = useState({
    expense_type: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateData, setUpdateData] = useState({
    expense_type: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateid, setUpdateId] = useState("");
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch data
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/expense_type.php`);
      setResponseData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData([]);
      toast.error("Error fetching data!", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Modal controls
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const closeUpdateModal = () => setUpdateModal(false);
  const handleOpenModal = (id, expense_type) => {
    setdeleteid(id);
    setdeletename(expense_type);
    setDeleteShowModals(true);
  };
  const handleCloseModal = () => setDeleteShowModals(false);

  // Add expense type
  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        expense_type: addData.expense_type,
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };
      await axios.post(`${ApiUrl}/Api/expense_type.php`, formData);
      setShowModal(false);
      setAddData({
        expense_type: "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      });
      toast.success("Expense Type added successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Error adding Expense Type!", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Update expense type
  const handleUpdate = (id, data) => {
    setUpdateId(id);
    setUpdateModal(true);
    setUpdateData({
      expense_type: data.expense_type,
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        expense_type: updateData.expense_type,
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };
      await axios.put(`${ApiUrl}/Api/expense_type.php/${updateid}`, formData);
      setUpdateModal(false);
      toast.success("Expense Type updated successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Error updating Expense Type!", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Delete expense type
  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/expense_type.php/${getdeleteid}`);
      toast.success("Expense Type deleted successfully!", 3000, "topRight");
      setDeleteShowModals(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Error deleting Expense Type!", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const filteredData = responseData.filter((item) =>
    item.expense_type?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li key={1} className={`page-item ${currentPage === 1 ? "active" : ""}`}>
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-3">
        <div className="row">
          <div className="col-lg-4">
            <div className="d-flex mb-4">
              <h6 className="card-title m-2">Expense Type</h6>
              <button
                className="btn btn-primary btn-sm rounded-3"
                onClick={openModal}
              >
                Add <span className="ms-2">+</span>
              </button>
            </div>
          </div>
          <div className="col-lg-6"></div>
          <div className="col-lg-2">
            <button
              className="btn btn-primary btn-md rounded-3"
              onClick={() => navigate("/expense")}
            >
              <i className="fa-solid fa-arrow-left"></i> Back
            </button>
          </div>
        </div>

        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              <div className="d-flex mb-2 mb-md-0">
                <label className="form-label text-dark mt-2">Show:</label>
                <div>
                  <select
                    className="form-control mx-2"
                    value={showAllItems ? "All" : itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="search-container w-25">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Expense Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item, index) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{item.expense_type}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-light me-1"
                            onClick={() => handleUpdate(item.id, item)}
                          >
                            <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-light"
                            onClick={() =>
                              handleOpenModal(item.id, item.expense_type)
                            }
                          >
                            <i className="fa-solid fa-trash text-danger fs-6"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-lg-6"></div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">&laquo;&laquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">&raquo;&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary">Add Expense Type</h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="expense_type" className="form-label">
                    Expense Type
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="expense_type"
                    name="expense_type"
                    value={addData.expense_type}
                    placeholder="Enter Expense Type"
                    onChange={(e) =>
                      setAddData({ ...addData, expense_type: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    onClick={handlesubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Update Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{ display: updateModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="updateCustomerModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary">Update Expense Type</h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="expense_type" className="form-label">
                    Expense Type
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="expense_type"
                    name="expense_type"
                    placeholder="Enter Expense Type"
                    value={updateData.expense_type}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        expense_type: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    onClick={handleupdatesubmit}
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete{" "}
                <span className="text-primary">{getdeletename}</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default ExpenseType;